import { i18n } from '@/i18n'
import { Capitalize } from '@/utils'

export default [
  {
    id: 'site-template',
    icon: ['fad', 'palette'],
    name: i18n.t('site:template:name'),
    triggerLabel: i18n.t('site:template:trigger'),
    description: i18n.t('site:template:description'),
    actionLabel: i18n.t('getInTouch'),
    price: {
      type: 'individual',
    },
  },
  {
    id: 'settlement',
    icon: ['fad', 'file-contract'],
    name: i18n.t('settlementServices'),
    description: i18n.t('settlementServicesDescription'),
    triggerLabel: i18n.t('assistanceSettlementService'),
    actionLabel: i18n.t('getInTouch'),
    price: {
      type: 'individual',
    },
  },
  {
    id: 'project-setup',
    icon: ['fad', 'cog'],
    name: i18n.t('setupProjectPageWithFlatfinder'),
    triggerLabel: i18n.t('doYouWantUsToSetupForYou'),
    description: i18n.t('weSetUpTheProject'),
    actionLabel: i18n.t('getInTouch'),
    price: {
      type: 'individual',
    },
  },
  {
    id: 'domain',
    icon: ['fad', 'globe'],
    name: i18n.t('domainSetup'),
    triggerLabel: i18n.t('doYouNeedAssistance'),
    description: i18n.t('domainSetupOffer'),
    actionLabel: i18n.t('getInTouch'),
    price: {
      type: 'individual',
    },
  },
  {
    id: 'contract',
    icon: ['fad', 'file-contract'],
    name: i18n.t('contractSetupKvass'),
    triggerLabel: i18n.t('setupHelp'),
    description: i18n.t('contractDataSetupOffer'),
    actionLabel: i18n.t('getInTouch'),
    price: {
      type: 'individual',
    },
  },
  {
    id: 'contract-suggestion',
    icon: ['fad', 'file-contract'],
    name: i18n.t('contractProposal'),
    triggerLabel: i18n.t('requestContractProposal'),
    description: i18n.t('parterMegleroppgjøretCustomTemplateForKvass'),
    actionLabel: i18n.t('getInTouch'),
    price: {
      type: 'individual',
    },
  },
  {
    id: 'custom-fields',
    icon: ['fad', 'cog'],
    name: i18n.t('extraFields'),
    triggerLabel: i18n.t('addMoreFields'),
    description: i18n.t('extraFieldsRecommendCustomTemplate'),
    actionLabel: i18n.t('getInTouch'),
    price: {
      type: 'individual',
    },
  },
  {
    id: 'shop',
    icon: ['fad', 'shopping-cart'],
    name: i18n.t('shop', 1),
    triggerLabel: Capitalize(i18n.tc('orderItem', { item: i18n.t('shop', 1).toLowerCase() })),
    link: 'https://www.kvass.no/produkter/tilvalg',
    description: i18n.t('shopModuleDescription'),
    actionLabel: i18n.t('order'),
    price: {
      type: 'individual',
    },
  },
  {
    id: 'broker-integration',
    icon: ['fad', 'shopping-cart'],
    name: i18n.t('integrationWithBrokerSystems'),
    triggerLabel: Capitalize(i18n.tc('orderItem', { item: i18n.t('integration', 1).toLowerCase() })),
    description: i18n.t('integrationWithBrokerSystemsDescription'),
    actionLabel: i18n.t('getInTouch'),
    price: {
      type: 'individual',
    },
  },
]
